import * as React from 'react';
import Text from 'components/Text';

type Props = {
  title?: string;
  children?: React.ReactNode;
};

export default function NavigationListSection(props: Props) {
  return (
    <section className="NavigationList-section">
      {props.title && (
        <Text color="graphite" size="xxsmall" element="h3" className="NavigationList-section-title">
          {props.title}
        </Text>
      )}
      {props.children}
    </section>
  );
}
